import React from 'react';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import { MdiReactIconComponentType } from 'mdi-react';

import { Spacing } from '@crm-framework/spacing';
import { EmptyState } from '@crm-framework/empty-state';
import { Loader } from '@crm-framework/loader';

export const BaseEmptyGridComponent: React.FC<{
  isLoading: boolean;
  emptyText: string;
  icon?: MdiReactIconComponentType;
}> = ({ isLoading, emptyText, icon }) => {
  const header = isLoading ? 'Data is searching' : 'No data found';
  const description = isLoading ? <Loader /> : emptyText;

  return (
    <Spacing mt={50}>
      <EmptyState
        icon={icon ?? MagnifyIcon}
        header={header}
        description={description}
      />
    </Spacing>
  );
};
